import NodeModel from 'rise-ui/models/types/node.js';

import { attr, hasMany } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import { load } from 'ember-async-data';
import { toArray } from 'rise-ui/utils/array.js';

export default class FileGalleryModel extends NodeModel {
  @attr('string') uuid;
  @attr('string') title;
  @attr('string') category;
  @attr fileMeta;
  @attr fileOrder;
  @hasMany('file-gallery-file', { async: true, inverse: 'fileGalleries' }) files;
  @cached get asyncFiles() {
    return load(this.files);
  }
  @cached get filesOrdered() {
    if (this.asyncFiles.isPending) {
      return this.asyncFiles;
    }
    const { fileMeta } = this;
    return toArray(this.asyncFiles.value, true)
      .sort((a, b) => fileMeta[a.id].index - fileMeta[b.id].index)
      .map(fgf => ({
        id: fgf.id,
        description: fileMeta[fgf.id].description,
        url: fgf.url,
        filename: fgf.filename,
        model: fgf,
      }));
  }
}
